import React from "react";
import classnames from "classnames";
import { useUIData } from "../hooks/useUIData";

interface CustomProps {
  overMenu?: boolean;
  children: any;
}

const PlainLayout: React.FunctionComponent<CustomProps> = (
  props: CustomProps
) => {
  const ui = useUIData();
  return (
    <div
      className={classnames({
        outer: true,
        "menu-expand": ui.sideMenuExpanded,
        "full-wrapper": props.overMenu,
      })}
    >
      {props.children}
    </div>
  );
};

export default PlainLayout;
